// color
export var RED = '#ee0a24'; // border

export var BORDER = 'van-hairline';
export var BORDER_TOP = BORDER + "--top";
export var BORDER_LEFT = BORDER + "--left";
export var BORDER_BOTTOM = BORDER + "--bottom";
export var BORDER_SURROUND = BORDER + "--surround";
export var BORDER_TOP_BOTTOM = BORDER + "--top-bottom";
export var BORDER_UNSET_TOP_BOTTOM = BORDER + "-unset--top-bottom";


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/utils/constant.js
// module id = 7
// module chunks = 26